export default {
  labelText: '{{name}}',
};



// WEBPACK FOOTER //
// ./src/widgets/toggleRefinement/defaultTemplates.js